"use client";

import { usePathname } from "next/navigation";

/**
 * Renders `minimalHeader` on the home route (search-first),
 * `fullHeader` on every other route. Pro subdomain is handled server-side in layout.
 */
export function HeaderSwitch({
  minimalHeader,
  fullHeader,
}: {
  minimalHeader: React.ReactNode;
  fullHeader: React.ReactNode;
}) {
  const pathname = usePathname() || "/";
  const path = pathname.replace(/^\/(fr|ar|en)(?=\/|$)/, "") || "/";
  const isHome = path === "/" || path === "";
  return <>{isHome ? minimalHeader : fullHeader}</>;
}
